import { useEffect, useState } from 'react';
import { useGameStore, useUserStore } from '../../store';
import {
  InventoryWidget,
  MainControls,
  MainNav,
} from '../../components';
import { FuelDrawer } from '../../components/FuelDrawer/FuelDrawer';
import { SESSION_STORAGE_DRAWER_KEY } from './Stage3';
import tgStar from '../../assets/icon-tg-star-gold.svg';
import { FightAnnouncement } from '../../components/FightWidgets/FightAnnouncement';
import { WebsocketIndicator } from '../../components/SocketIOContext/WebsocketIndicator';
import { EnergyBar } from '../../components/MainControls/EnergyBar';

export const Stage2 = () => {
  const { user } = useUserStore();
  const { incomingBattleState, gameMode } = useGameStore();
  const [isNeedShown, setIsNeedShown] = useState(false);
  const [isInventoryWidgetShown, setIsInventoryWidgetShown] = useState(false);
  const [isFuelDrawerOpen, setIsFuelDrawerOpen] = useState(false);

  const fuelUp = () => {
    setIsFuelDrawerOpen(true);
  };

  useEffect(() => {
    if (user.energy === null) {
      return;
    }

    const isShown = localStorage.getItem(SESSION_STORAGE_DRAWER_KEY);

    if (user.energy > 0 && isShown) {
      localStorage.removeItem(SESSION_STORAGE_DRAWER_KEY);
    }

    if (user.energy <= 1) {
      if (isShown) {
        return;
      }

      setIsFuelDrawerOpen(true);
      localStorage.setItem(SESSION_STORAGE_DRAWER_KEY, 'true');
    }
  }, [user.energy]);

  useEffect(() => {
    if (!isInventoryWidgetShown && (user.hunger < 1 || user.health < 1 || user.happiness < 1)) {
      const timeoutId = setTimeout(() => {
        if (user.hunger < 1 || user.health < 1 || user.happiness < 1) {
          setIsNeedShown(true);
        }
      }, 1500);

      return () => clearTimeout(timeoutId);
    }
  }, [isNeedShown, isInventoryWidgetShown, gameMode, user.hunger, user.health, user.happiness]);

  if (user.energy === null) {
    return null;
  }

  return (
    <>
      <div className="w-full flex flex-col items-center">
        {isInventoryWidgetShown && <InventoryWidget need="food" setIsShown={setIsInventoryWidgetShown} />}
        <div className="w-full bottom-28 absolute flex flex-col items-center">
          {user.energy <= 50 && (
            <button
              className="mb-4 rounded-2xl py-3 px-4 space-x-2.5 flex w-fit bg-[#00000059] active:bg-[#0000008c]"
              onClick={fuelUp}
            >
              <div className="text-white text-[16px] flex font-semibold">⚡️ Fuel up</div>
              <div
                className="flex items-center space-x-1 py-[2px] px-[7px] rounded-[12px]"
                style={{
                  background:
                    'var(linear-gradient(130deg, rgba(253, 210, 26, 0.20) -21.52%, rgba(228, 123, 3, 0.20) 88.07%))',
                  backdropFilter: 'blur(10px)',
                }}
              >
                <img src={tgStar} alt="tg-star" />
                <div
                  className="text-[12px] font-semibold"
                  style={{
                    color: '#FDD21A',
                  }}
                >
                  {30 + (user.level * 10)}
                </div>
              </div>
            </button>
          )}

          <EnergyBar />
        </div>
      </div>

      <MainControls isAllowedToFight="info" />
      <MainNav isBranch gameMode={gameMode} />
      <FuelDrawer isOpen={isFuelDrawerOpen} setIsOpen={setIsFuelDrawerOpen} />
      {incomingBattleState && <FightAnnouncement />}
      <WebsocketIndicator />
    </>
  );
};
